import { stylesheet } from 'typestyle';
import { colors, font } from '../../assets/styles';

const styles = stylesheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '60px',
    paddingBottom: '40px',
  },
  imageWrapper: {
    marginBottom: '20px',
  },
  title: {
    fontWeight: font.weight.light,
    fontSize: '28px',
    lineHeight: '36px',
  },
  subtitle: {
    color: colors.foregroundLighter,
    fontSize: '16px',
    lineHeight: '20px',
  },
});

export default styles;
